module.exports = __webpack_public_path__ + "img/HQ-PA2W1CH-T.8db55ee5.jpg";